<template>
  <el-container class="NoteForm">
    <el-main class="p-0">
      <el-form
        ref="form"
        label-width="80px"
        class="form-label-90"
        :model="data"
        :rules="rules"
        inline
      >
        <el-row>
          <el-col :span="12">
            <el-form-item label="어음번호" prop="number">
              <el-input v-model="data.number" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="구분" prop="type_flag">
              <el-select v-model="data.type_flag">
                <el-option
                  v-for="opt in system.options.note_type_flag"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="금액" prop="price">
              <ANumberInput v-model="data.price" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <el-form-item label="지급일" prop="pay_date">
              <ADatePicker v-model="data.pay_date" :clearable="false" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="발행일" prop="publish_date">
              <ADatePicker v-model="data.publish_date" :clearable="false" />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="발행자" prop="publisher">
              <el-input v-model="data.publisher" />
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item label="발행은행" prop="bank_name">
              <el-input v-model="data.bank_name" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <el-form-item
              label="입고일"
              prop="in_date"
              v-if="this.noteFlag.indexOf('in') > -1"
            >
              <ADatePicker v-model="data.in_date" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item
              label="구분"
              prop="in_flag"
              v-if="this.noteFlag.indexOf('in') > -1"
            >
              <el-select v-model="data.in_flag">
                <el-option
                  v-for="opt in system.options.note_in_flag"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item
              label="입고처"
              prop="in_customer_name"
              v-if="this.noteFlag.indexOf('in') > -1"
            >
              <ACustomerSelector
                v-model="data.in_customer_name"
                placeholder="입고처"
                :disabled="!!inCustomer"
                seller
                @select="handleSelectInCustomer"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <el-form-item
              label="출고일"
              prop="out_date"
              v-if="this.noteFlag.indexOf('out') > -1"
            >
              <ADatePicker v-model="data.out_date" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item
              label="구분"
              prop="out_flag"
              v-if="this.noteFlag.indexOf('out') > -1"
            >
              <el-select v-model="data.out_flag">
                <el-option
                  v-for="opt in system.options.note_out_flag"
                  :key="opt.value"
                  :label="opt.label"
                  :value="opt.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item
              label="출고처"
              prop="out_customer_name"
              v-if="this.noteFlag.indexOf('out') > -1"
            >
              <ACustomerSelector
                v-model="data.out_customer_name"
                placeholder="출고처"
                :disabled="!!outCustomer"
                buyer
                @select="handleSelectOutCustomer"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="5">
            <el-form-item label="배서인1" prop="endorser1">
              <el-input v-model="data.endorser1" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="배서인2" prop="endorser2">
              <el-input v-model="data.endorser2" />
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="배서인3" prop="endorser3">
              <el-input v-model="data.endorser3" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item
              label="기록사항"
              prop="desc"
              class="custom-form-item w-full"
            >
              <el-input
                maxlength="200"
                type="textarea"
                v-model="data.desc"
                :rows="2"
                placeholder="200자 이내"
                show-word-limit
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <el-dialog
        title="어음 가져오기"
        top="0"
        custom-class="form-dialog"
        :visible.sync="dialog_visible"
        :close-on-click-modal="false"
        :modal="false"
        destroy-on-close
      >
        <NoteSelectForm
          v-if="dialog_visible"
          @completed="handleCompletedNoteSelect"
        />
      </el-dialog>
    </el-main>
    <el-footer>
      <el-button
        type="primary"
        v-shortkey="['f4']"
        :disabled="!has_grant_write"
        :loading="load_button"
        @shortkey.native="handleClickRegister"
        @click="handleClickRegister"
        >{{ isNew ? "등록" : "수정" }} (F4)</el-button
      >
      <el-button v-if="outCustomer" @click="handleClickNoteSelect"
        >어음 가져오기</el-button
      >
      <el-button
        type="danger"
        v-if="!isNew && !outCustomer"
        :disabled="!has_grant_write"
        :loading="load_button"
        @click="handleClickDelete"
        >삭 제</el-button
      >
      <el-button class="close-button" @click="closeDialog"
        >{{ $t("button.close") }}(Esc)</el-button
      >
    </el-footer>
  </el-container>
</template>
<script>
import { form } from "@/common/mixins/form";
import NoteSelectForm from "./NoteSelectForm";

export default {
  name: "NoteForm",
  mixins: [form],
  components: { NoteSelectForm },
  data() {
    var validateInCustomerName = (rule, value, callback) => {
      if (value !== "" && this.data.in_date === null) {
        callback(new Error("입고처를 지정하면, 입고일을 설정해야 합니다."));
      } else {
        callback();
      }
    };
    var validateOutCustomerName = (rule, value, callback) => {
      if (value !== "" && this.data.out_date === null) {
        callback(new Error("출고처를 지정하면, 출고일을 설정해야 합니다."));
      } else {
        callback();
      }
    };
    return {
      title: this.$t("title.note"),
      rules: {
        number: [{ required: true, message: "번호를 입력하세요." }],
        price: [
          { required: true, message: "지급일을 선택하세요." },
          { type: "number", min: 1, message: "금액을 입력하세요." },
        ],
        pay_date: [{ required: true, message: "지급일을 선택하세요." }],
        publish_date: [{ required: true, message: "발행일을 선택하세요." }],
        publisher: [{ required: true, message: "발행자를 입력하세요." }],
        in_customer_name: [{ validator: validateInCustomerName }],
        out_customer_name: [{ validator: validateOutCustomerName }],
      },
      dialog_visible: false,
      load_button: false,
    };
  },
  props: {
    data: {
      type: Object,
      default: function() {
        return {
          id: 0,
          number: "",
          type_flag: "B",
          price: 0,
          pay_date: null,
          publish_date: null,
          publisher: "",
          bank_name: "",
          in_date: null,
          in_flag: "1",
          in_customer_id: null,
          in_customer_name: "",
          out_date: null,
          out_flag: "0",
          out_customer_id: null,
          out_customer_name: "",
          endorser1: "",
          endorser2: "",
          endorser3: "",
          desc: "",
        };
      },
    },
    inCustomer: {
      type: Object,
    },
    outCustomer: {
      type: Object,
    },
    noteFlag: {
      type: String,
    },
    has_grant_write: {
      type: Boolean,
      default: false,
    },
  },
  mounted() {
    if (this.inCustomer) {
      this.data.in_customer_id = this.inCustomer.id;
      this.data.in_customer_name = this.inCustomer.name;
      if (this.isNew) {
        this.data.in_date = this.util.getDate(0);
        this.data.in_flag = "2";
      }
    }
    if (this.outCustomer) {
      this.setOutCustomerData();
    }
  },
  computed: {
    isNew: function() {
      return this.data.id < 1;
    },
  },
  methods: {
    doRegister() {
      let data = Object.assign({}, this.data);
      let api = this.isNew ? this.api.createNote : this.api.updateNote;
      let message = this.isNew ? "등록되었습니다." : "수정되었습니다.";
      this.load_button = true;
      api(data).then((res) => {
        this.load_button = false;
        this.handleResponseResult(res, message);
      });
    },
    doDelete() {
      let data = Object.assign({}, this.data);
      this.load_button = true;
      this.api.deleteNote(data).then((res) => {
        this.load_button = false;
        this.handleResponseResult(res, "삭제되었습니다.");
      });
    },
    setOutCustomerData() {
      this.data.out_customer_id = this.outCustomer.id;
      this.data.out_customer_name = this.outCustomer.name;
      if (this.isNew) {
        this.data.out_date = this.util.getDate(0);
        this.data.out_flag = "2";
      }
    },
    handleSelectInCustomer(c) {
      if (typeof c === "string") {
        this.data.in_customer_id = null;
        this.data.in_customer_name = c;
      } else {
        this.data.in_customer_id = c.id;
        this.data.in_customer_name = c.name;
      }
    },
    handleSelectOutCustomer(c) {
      if (typeof c === "string") {
        this.data.out_customer_id = null;
        this.data.out_customer_name = c;
      } else {
        this.data.out_customer_id = c.id;
        this.data.out_customer_name = c.name;
      }
    },
    handleClickRegister() {
      if (!this.has_grant_write) {
        return;
      }
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.doRegister();
      });
    },
    handleClickDelete() {
      this.util.confirm_delete(this, this.title, this.doDelete);
    },
    handleResponseResult(res, message) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.title, res);
        return;
      }
      this.util.notify_success(this, this.title, message);
      this.$emit("completed", true);
    },
    handleClickNoteSelect() {
      this.dialog_visible = true;
    },
    handleCompletedNoteSelect(result) {
      this.dialog_visible = false;
      if (!result) {
        return;
      }
      this.util.copyObject(result, this.data);
      this.setOutCustomerData();
    },
  },
};
</script>
